import React, { useState, useEffect, useContext } from 'react';
import { getJustificationCustomCompanyList, deleteJustificationCustomCompany } from '../services/api_justifications';
import { AuthContext } from '../contexts/auth';
import { ArrowDownIcon, ArrowUpIcon, PauseIcon, PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline';
import Swal from 'sweetalert2';
import EditJustificationForm from './form_edit_justification';
import Fetching from './fetching';


const GiustificativiCustomTable = ({ giustificativi, onDeleteCustomJustification, onUpdateJustification }) => {
  const { token } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showFormEdit, setShowFormEdit] = useState(false);
  const [selectedJustification, setSelectedJustification] = useState(null);


  const handleDeleteJustificationCustom = async (giustificativo) => {
    if (!giustificativo || !giustificativo.id) {
        console.error("Giustificativo non valido");
        return;
    }

    const justificationId = giustificativo.id.toString();
    Swal.fire({
      text: `Stai eliminando il giustificativo personalizzato '${giustificativo.description}'. Confermi?`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonColor: '#D1D5DB',
      confirmButtonText: 'Si, sono sicuro!',
      cancelButtonText: 'Annulla',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true); 
        try {
          await deleteJustificationCustomCompany(token, justificationId);
          onDeleteCustomJustification(giustificativo.id);
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Eliminato!",
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            console.error("Errore durante l'eliminazione del giustificativo:", error);
            Swal.fire({
                title: 'Errore!',
                text: 'Si è verificato un errore durante l\'eliminazione del giustificativo',
                icon: 'error'
            });
        } finally {
          setIsLoading(false);
        }
      }
    }); 
  };  

  const onEditFormOpen = (justification) => {
    setSelectedJustification(justification);
    setShowFormEdit(true);
  }; 
  
  if(isLoading)
    return <Fetching />
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div className="mt-5 mx-10 overflow-x-auto">
      {giustificativi.length === 0 ? (
        <div className="m-8 rounded-lg border-2 border-dashed border-gray-300 p-6 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-sm font-semibold text-gray-500">
          <div className="text-center items-center">
            <p>Non sono presenti Giustificativi personalizzati</p>
          </div>
        </div>
      ) : (
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th colSpan={1} className="py-3 pl-10 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Codice</th>
              <th colSpan={1} className="py-3 pl-6 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">ID esterno</th>
              <th colSpan={2} className="py-3 pl-10 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Descrizione</th>
              <th colSpan={2} className="py-3 pl-10 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Azione sulle Ore lavorate</th>
              <th colSpan={2} className="py-3 pl-10 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Rateo</th>
              <th colSpan={2} className="py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">Azioni</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {giustificativi.map((giustificativo, giustificativoIdx) => (
               <React.Fragment key={giustificativoIdx}>
                <tr>
                  <td colSpan={1} className="px-4 pl-10 whitespace-nowrap text-gray-500 text-sm">{giustificativo.code}</td>
                  <td colSpan={1} className="px-4 pl-6 whitespace-nowrap text-gray-500 text-sm">
                    {giustificativo.external_reference || ''}
                  </td>
                  <td colSpan={2} className="px-4 pl-10 whitespace-nowrap text-gray-500 text-sm">{giustificativo.description}</td>
                  <td colSpan={2} className="px-4 pl-10 whitespace-nowrap text-gray-500 text-sm">
                    {giustificativo.strategy === "increase" ? (
                      <>
                        <ArrowUpIcon className="inline-block h-3 w-3 text-indigo-500" /> Aumenta
                      </>
                    ) : giustificativo.strategy === "decrease" ? (
                      <>
                        <ArrowDownIcon className="inline-block h-3 w-3 text-gray-900" /> Riduce
                      </>
                    ) : (
                      <>
                        <PauseIcon className="inline-block h-3 w-3 text-gray-900" /> Nessuna azione
                      </>
                    )}
                  </td>
                  <td colSpan={2} className="px-4 pl-10 whitespace-nowrap text-gray-500 text-sm">{giustificativo.rateo?.rateo?.name}</td>
                  <td colSpan={2} className="px-4 py-2 pl-10 whitespace-nowrap text-gray-500 text-sm justify-center flex">
                    <button
                      onClick={() => onEditFormOpen(giustificativo)}
                      className="border flex items-center rounded-md bg-grey-400 px-3 py-1 text-center text-xs font-semibold text-gray-900 shadow-sm hover:bg-indigo-400 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 justify-center me-3"
                    >
                      <PencilSquareIcon className='w-4 h-4 inline-block' />
                    </button>
                    <button
                      onClick={() => handleDeleteJustificationCustom(giustificativo)}
                      className="border flex items-center rounded-md bg-grey-400 px-3 py-1 text-center text-xs font-semibold text-gray-900 shadow-sm hover:bg-gray-200 hover:text-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 justify-center"
                    >
                      <TrashIcon className='w-4 h-4 inline-block' />
                    </button>
                  </td>
                </tr>
              {showFormEdit && selectedJustification === giustificativo && (
                <tr>
                  <td colSpan={10}>
                    <div className="rounded border border-grey-400 p-4 w-full my-4">
                      <h1 className="text-sm font-semibold leading-6 text-gray-900">MODIFICA GIUSTIFICATIVO</h1> 
                      <div>
                        <EditJustificationForm 
                          onCancel={() => setShowFormEdit(false)}
                          justification={selectedJustification}
                          onUpdateJustification={onUpdateJustification}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default GiustificativiCustomTable;
